import qs from 'qs';
import axiosClient from './axiosClient';
import { serviceBase } from './serviceBase';

export const getFiscalCapitalBalanceList = serviceBase({
  request: options =>
    axiosClient.get('/accounting/fiscal-capital-balance', {
      params: options,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      }
    }),
  retry: 0
});

export const downloadExportedFiscalCapitalBalance = serviceBase({
  request: options =>
    axiosClient.get('/accounting/fiscal-capital-balance/export', {
      responseType: 'blob',
      params: options,
      timeout: 120000
    }),
  transformResponse: res => {
    try {
      const filename = 'Balance de capital.xlsx';
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
    } catch (error) {
      console.log(`Opps, un error: ${error}`);
      console.error(error);
    }
  },
  retry: 0
});

export const getAccountingCapitalBalanceList = serviceBase({
  request: options =>
    axiosClient.get('/accounting/accounting-capital-balance', {
      params: options,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      }
    }),
  retry: 0
});

export const downloadExportedAccountingCapitalBalance = serviceBase({
  request: options =>
    axiosClient.get('/accounting/accounting-capital-balance/export', {
      responseType: 'blob',
      params: options,
      timeout: 120000
    }),
  transformResponse: res => {
    try {
      const filename = 'Balance contable de capital.xlsx';
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
    } catch (error) {
      console.log(`Opps, un error: ${error}`);
      console.error(error);
    }
  },
  retry: 0
});
export const getFiscalCapitalBalanceSummary = serviceBase({
  request: options =>
    axiosClient.get('/contracts/balances/summary/fiscal-capital', {
      params: options,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      }
    }),
  retry: 0
});

export const getAccountingCapitalBalanceSummary = serviceBase({
  request: options =>
    axiosClient.get('/contracts/balances/summary/accounting-capital', {
      params: options,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      }
    }),
  retry: 0
});
